// extracted by mini-css-extract-plugin
module.exports = {"blogLatestPosts":"blog-latest-posts-module--blog-latest-posts--2V3cK","blogLatestPosts__title":"blog-latest-posts-module--blog-latest-posts__title--26r5E"};